"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sanitizeIssueAttributeMap = exports.convertCustomAttrObjToArray = void 0;
var _trim = _interopRequireDefault(require("lodash/trim"));
var _mapValues = _interopRequireDefault(require("lodash/mapValues"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const TEXT_ATTRIBUTES = ["title", "locationDetails", "description"];
const convertCustomAttrObjToArray = customAttrObj => {
  return Object.entries(customAttrObj).map(_ref => {
    let [attributeDefinitionId, value] = _ref;
    return {
      attributeDefinitionId,
      value: typeof value === "string" ? (0, _trim.default)(value) : value
    };
  });
};
exports.convertCustomAttrObjToArray = convertCustomAttrObjToArray;
const sanitizeIssueAttributeMap = inputIssueData => {
  return (0, _mapValues.default)(inputIssueData, (value, key) => {
    if (TEXT_ATTRIBUTES.includes(key)) {
      if (!value) {
        return "";
      }
      return (0, _trim.default)(value);
    }
    if (key === "customAttributes") {
      return convertCustomAttrObjToArray(value);
    }
    return value;
  });
};
exports.sanitizeIssueAttributeMap = sanitizeIssueAttributeMap;
//# sourceMappingURL=issueFieldSanitization.js.map